const variables = {
	darkGrey: '#000000',

	midGrey: '#666666',
	altGrey: '#7C7C7A',

	lightGrey: '#F3F1F0',
	general: '#F3F1F0',

	subduedGrey: '#9f9f9f',

	lineColor: '#E4E4E4',
	white: '#FFFFFF',

	borderColor: '#d8d8d8',

	yellow: '#fff980',
	skin: '#fff980',
	acne: '#fff980',
	WRINKLE: '#fff980',
	FILI: '#fff980',
	wrinkles: '#fff980',
	hyperpigmentation: '#fff980',
	rosacea: '#fff980',
	lightYellow: '#EAE980',

	skyBlue: '#9BD4FF',
	eyelashes: '#9BD4FF',
	LATISSE: '#9BD4FF',
	LASH: '#9BD4FF',
	lightBlue: '#DBEFFF',

	mint: '#94CFC4',
	hairloss: '#94CFC4',
	MPB: '#94CFC4',
	HAIR: '#94CFC4',
	lightMint: '#E4F3F0',

	coral: '#F2C3B1',
	sweating: '#F2C3B1',
	error: '#FF4646',

	tropicalBlue: '#CBE6F8',

	newYellow: '#fff980',
	newLightYellow: '#FFFEE6',
	background: 'rgb(231, 231, 231)',

	// ADMIN colors
	primaryBlue: '#0d68a8',
	lightBlue: '#e6f0f3',
	midBlue: '#1e98af',
	darkBlue: '#3698db',
	linkBlue: '#3ba2b5',
	tealDark: '#006368',

	navHeight: 100,
	mobileNavHeight: 72,
	mobileNavHeightOpen:54,
	navHeightScrolled: 75,
	menuGutter: 70,
	menuGutterMobile: 20,
	borderWidth: 10,
	defaultBorderRadius: '.25rem',
	defaultBoxShadow: '0 2px 4px 0 rgba(208, 208, 208, 0.5)',
	cardShadow: '0px 2px 4px rgba(51, 51, 51, 0.08)',

	newBackgroundColor: '#FFFEFA',
};

export default variables;
